import addGenericFilters from 'Components/UI/EATable/addGenericFilters'

const columns = [
  addGenericFilters({
    dataIndex: 'produto',
    title: 'Produto',
    searchable: true,
    sortAsText: true
  }),
  {
    dataIndex: 'qtd',
    title: 'Quantidade',
    type: 'number',
    align: 'right'
  },
  {
    dataIndex: 'vltaxaservico',
    title: 'Taxa Serviço',
    type: 'number',
    align: 'right'
  },
  {
    dataIndex: 'vendaliquida',
    title: 'Venda Líquida',
    type: 'number',
    align: 'right'
  }
]

export default columns
